import React, { useEffect, useRef, useState } from "react";
import TableDmdonvitinhList from "./TableDmdonvitinhList";
import { useDispatch, useSelector } from "react-redux";
import { getAllDmdonvitinh } from "store/slices/sale/danhmucSlice";
import MeditechTablePage, { FilterComponent } from "components/table-layout";
const initSearch = {
  searchText: null,
};
export const initDmdonvitinh = {
  action: "initial",
  isRequired: true,
};
const DmdonvitinhList = () => {
  const dispatch = useDispatch();
  const { permitList } = useSelector((state) => state.auth);
  const { allDmdonvitinhList, loading } = useSelector(
    (state) => state.danhMucSale
  );
  useEffect(() => {
    reloadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const reloadData = () => {
    searchFormRef.current = { ...searchFormRef.current };
    dispatch(getAllDmdonvitinh(searchFormRef.current));
  };

  const searchFormRef = useRef({ ...initSearch });
  const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
  const searchHandle = (dataSearch) => {
    searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
    setSearchFormData({ ...searchFormRef.current });
    reloadData();
  };

  const onRenderSearchView = () => {
    return (
      <FilterComponent
        datasource={searchFormData}
        onSearchImmediate={searchHandle}
        // renderFilterMoreView={renderFilterMoreView}
        renderInputSearch
        renderDatePicker={false}
      />
    );
  };

  // const onDeleteHandler = (id) => {
  //   // dispatch(
  //   //   DeletePhuongAnKinhDoanh({
  //   //     id: id,
  //   //     onSuccess: ({ data }) => {
  //   //       if (data.isOk) {
  //   //         reloadData();
  //   //         notification.info({
  //   //           message: "Xóa phương án kinh doanh",
  //   //           description: "Xóa phiếu thành công",
  //   //         });
  //   //       } else {
  //   //         notification.error({
  //   //           message: "Xóa phương án kinh doanh",
  //   //           description: data.description,
  //   //         });
  //   //       }
  //   //     },
  //   //   })
  //   // );
  // };

  // const onOpenDetailHandler = (id) => {
  //   // setPhuongAnId(id);
  //   // setVisibleModal(true);
  // };

  const getRightButton = (isLocked) => {
    const arr = [];
    if (isLocked) {
      // arr.push({
      //   keyName: SystemButtonSource.addBtn,
      //   title: "Thêm",
      //   showMore: false,
      //   // disable: !allowAddNew,
      // });
    }
    return arr;
  };

  const onRightTopBtnHandler = (key) => {
    // switch (key) {
    //   case SystemButtonSource.addBtn:
    //     setVisibleModal((prev) => !prev);
    //     break;
    //   default:
    //     break;
    // }
  };
  return (
    <>
      <MeditechTablePage
        tableTitle="DANH MỤC ĐƠN VỊ TÍNH"
        btnHeaderRightSource={getRightButton(true)}
        btnHeaderRightSourceHandle={onRightTopBtnHandler}
        onRenderSearchView={onRenderSearchView}
      >
        <TableDmdonvitinhList
          loading={loading}
          dmDonViTinhList={allDmdonvitinhList}
          reloadData={() => reloadData()}
          permitList={permitList}
        />
      </MeditechTablePage>
    </>
  );
};

export default DmdonvitinhList;
